module.exports = __webpack_public_path__ + "img/bfb12382-f27c-4985-b9b4-26c6080bf23d.1453f820.png";